var map = {
	"./ESERVICE.png": "5453",
	"./ETAPAS.png": "1cfe",
	"./MUSLIMNESIA.png": "ce36",
	"./MYPORT.png": "c7ae",
	"./PPID.png": "9eb2",
	"./PUSDIKLAT.png": "1892",
	"./SMI.png": "815e",
	"./port1.png": "d8b5",
	"./port2.png": "cc10",
	"./port3.png": "ec77",
	"./port4.png": "1b2a",
	"./port5.png": "49ee",
	"./port6.png": "6f5f",
	"./port7.png": "7ed1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0ec8";